import { Component, OnInit } from '@angular/core';
import { IAccount } from '../../../store/models/account.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ISelectItem } from '../../../store/models/select.model';
import { ContactsService } from '../../../store/services/contacts.service';
import { IContactGroup } from '../../../store/models/contact.model';

@Component({
  selector: 'app-batch-move-dialog',
  templateUrl: './batch-move-dialog.component.html',
  styleUrls: ['./batch-move-dialog.component.scss'],
})
export class BatchMoveDialogComponent implements OnInit {
  accounts: IAccount[];
  groups: IContactGroup[];

  inputForm: FormGroup;

  componentReady = false;

  constructor(private readonly contactService: ContactsService) {
  }

  get items(): ISelectItem[] {
    return this.accounts.map(a => ({
      label: `${a.first_name} ${a.last_name}`,
      value: a.account_id,
    }));
  }

  get groupItems(): ISelectItem[] {
    if (!this.groups) {
      return [];
    }

    return this.groups.map(g => ({
      label: g.group_name,
      value: g.group_id,
    }));
  }

  ngOnInit(): void {
    if (this.inputForm) {
      this.inputForm.addControl(
        'accountId',
        new FormControl('', [Validators.required]),
      );
      this.inputForm.addControl(
        'groupId',
        new FormControl('', [Validators.required]),
      );

      this.componentReady = true;
    }
  }

  onAccountSelection($event: any) {
    if ($event) {
      this.contactService.getContactGroups($event).subscribe(groups => {
        this.groups = groups;
      });
    }
  }
}
